// ElapsedTimeChip.tsx
import React, { useEffect, useState } from 'react';
import { Chip } from '@mui/material';

interface ElapsedTimeChipProps {
  startDate: string; // ISO date string or any parsable date string
}

const ElapsedTimeChip: React.FC<ElapsedTimeChipProps> = ({ startDate }) => {
  const [elapsedTime, setElapsedTime] = useState<string>('');

  useEffect(() => {
    const startTime = new Date(startDate);

    const updateElapsedTime = () => {
      const now = new Date();
      const totalSeconds = Math.floor((now.getTime() - startTime.getTime()) / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      setElapsedTime(
        `${String(hours).padStart(2, '0')}:` +
        `${String(minutes).padStart(2, '0')}:` +
        `${String(seconds).padStart(2, '0')}`
      );
    };

    updateElapsedTime();
    const intervalId = setInterval(updateElapsedTime, 1000);
    return () => clearInterval(intervalId);
  }, [startDate]);

  return (
    <Chip
      label={elapsedTime}
      sx={{ alignSelf: 'flex-start' }}
    />
  );
};

export default ElapsedTimeChip;
